export default {
	groups: {
		marketing: 'Explore',
		support: 'Support',
		tools: 'Tools',
	},
	sidebar: {
		studyPanel: 'My library',
		collections: '{{collectionEntityLabelPlural}}',
		courses: '{{mainEntityLabelPlural}}',
		topics: 'Topics',
		templates: 'Templates',
		personalTrail: 'My trail',
		favoriteCourses: 'Favorite {{mainEntityLabelPlural}}',
		unpinCourse: 'Unpin {{mainEntityLabelLower}}',
		lastTopics: 'Last topics',
		navigation: 'Navigation',
		search: 'Search',
		searchPlaceholder: 'Search your content',
		support: {
			title: 'Support',
			documentation: 'Documentation',
			askForFeature: 'Ask for a feature',
			contactUs: 'Contact us',
			tour: 'Take the guided tour',
			reportBug: {
				title: 'Request help',
				header: 'Submit help request',
				emailLabel: 'Email',
				subjectLabel: 'Subject',
				messageLabel: 'How can I help you?',
				receivedRequestMessage:
					'Thanks for getting in touch. I will get back to you as soon as possible.',
			},
		},
		settings: 'Settings',
		theme: {
			toggle: 'Theme',
			switchToDark: 'Switch to dark mode',
			switchToLight: 'Switch to light mode',
		},
		logout: {
			title: 'Logout',
			dialogTitle: 'Are you sure you want to log out?',
			dialogCancel: 'Cancel',
			dialogConfirm: 'Continue',
		},
		profile: 'Profile',
		user: 'User area',
	},
	sidebarAdmin: {
		users: 'Users',
		roles: 'Roles',
		courses: '{{mainEntityLabelPlural}}',
		modules: 'Modules',
		topics: 'Topics',
		insights: 'Insights',
		configStudio: 'Config Studio',
		emailStudio: 'Email Studio',
		emailSequences: 'Email sequences',
		documentation: 'Internal Docs',
	},
	breadcrumb: {
		home: 'Home',
		courses: '{{mainEntityLabelPlural}}',
		topics: 'Topics',
		resources: 'Resources',
		admin: 'Admin',
		dashboard: 'Dashboard',
	},
	paths: {
		allowedRoles: 'Allowed roles',
		deniedRoles: 'Denied roles',
		home: { enabled: 'Home', path: 'Home path' },
		dashboard: { enabled: 'Dashboard', path: 'Dashboard path' },
		auth: {
			login: { enabled: 'Login', path: 'Login path' },
			signup: { enabled: 'Signup', path: 'Signup path' },
			forgotPassword: {
				enabled: 'Forgot password',
				path: 'Forgot password path',
			},
			verify: { enabled: 'Verify', path: 'Verify path' },
			onboarding: { enabled: 'Onboarding', path: 'Onboarding path' },
			resetPassword: { enabled: 'Reset password', path: 'Reset password path' },
		},
		courses: {
			base: {
				enabled: '{{mainEntityLabelPlural}} index',
				path: '{{mainEntityLabelPlural}} index path',
			},
			detail: {
				enabled: '{{mainEntityLabel}} detail',
				path: '{{mainEntityLabel}} detail path',
			},
			study: {
				enabled: '{{mainEntityLabel}} study',
				path: '{{mainEntityLabel}} study path',
			},
			project: {
				enabled: '{{mainEntityLabel}} project',
				path: '{{mainEntityLabel}} project path',
			},
			diagram: {
				enabled: '{{mainEntityLabel}} diagram',
				path: '{{mainEntityLabel}} diagram path',
			},
			notes: {
				enabled: '{{mainEntityLabel}} notes',
				path: '{{mainEntityLabel}} notes path',
			},
		},
		marketing: {
			courses: { enabled: 'Catalog', path: 'Catalog path' },
			courseDetail: {
				enabled: 'Catalog {{mainEntityLabelLower}} detail',
				path: 'Catalog {{mainEntityLabelLower}} detail path',
			},
			coursePreview: {
				enabled: 'Catalog {{mainEntityLabelLower}} preview',
				path: 'Catalog {{mainEntityLabelLower}} preview path',
			},
		},
		publicCourses: {
			base: {
				enabled: 'Public {{mainEntityLabelPluralLower}}',
				path: 'Public {{mainEntityLabelPluralLower}} path',
			},
			detail: {
				enabled: 'Public {{mainEntityLabelLower}} detail',
				path: 'Public {{mainEntityLabelLower}} detail path',
			},
			preview: {
				enabled: 'Public {{mainEntityLabelLower}} preview',
				path: 'Public {{mainEntityLabelLower}} preview path',
			},
		},
		admin: {
			users: { base: { enabled: 'Admin users', path: 'Admin users path' } },
			roles: { base: { enabled: 'Admin roles', path: 'Admin roles path' } },
			courses: {
				base: {
					enabled: 'Admin {{mainEntityLabelPluralLower}}',
					path: 'Admin {{mainEntityLabelPluralLower}} path',
				},
			},
			configStudio: {
				base: { enabled: 'Config Studio', path: 'Config Studio path' },
			},
		},
		static: {
			legal: { enabled: 'Legal', path: 'Legal path' },
			blog: { enabled: 'Blog', path: 'Blog path' },
			about: { enabled: 'About', path: 'About path' },
			contact: { enabled: 'Contact', path: 'Contact path' },
		},
	},
}
